import styled from 'styled-components';
import Button from '../Button';
import { PHONE_MEDIA_QUERY, useMediaQuery } from '../../common/responsive';
import { useNavigate, useLocation } from 'react-router-dom';

const Container = styled.div`
  height: 100px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: 80px;
  padding-right: 80px;
  @media ${PHONE_MEDIA_QUERY} {
    padding-left: 15px;
    padding-right: 15px;
  }
`;

const ItemsContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 40px;
`;

const RightItemsContainer = styled(ItemsContainer)`
  gap: 16px;
  justify-content: flex-end;
  width: 300px;
`;

const HIDE_LOGIN_ROUTES = ['/survey'];

const Navbar = () => {
  const isMobile = useMediaQuery(PHONE_MEDIA_QUERY);
  const navigate = useNavigate();
  const location = useLocation();

  const shouldShowLoginButton = !HIDE_LOGIN_ROUTES.includes(location.pathname);

  return (
    <>
      <Container>
        <img
          style={{
            width: isMobile ? 150 : 200,
          }}
          src='/logo.webp'
        />
        <RightItemsContainer>
          {shouldShowLoginButton && (
            <Button
              onClick={() => {
                navigate('/app/home');
              }}
            >
              Start Now
            </Button>
          )}
        </RightItemsContainer>
      </Container>
    </>
  );
};

export default Navbar;
